import { FC } from 'react'

import { ContributionSize, Project, WhoPays } from '@/components/InteractiveCheckout/CheckoutChips'
import InteractiveGameDisplay from '@/components/InteractiveGameDisplay'

const desktopImageSlugs = [
    'biochar-consumer-delivery',
    'biochar-consumer-percentage',
    'biochar-consumer-purchase',
    'biochar-consumer-roundup',
    'biochar-merchant-delivery',
    'biochar-merchant-percentage',
    'biochar-merchant-purchase',
    'biochar-split-delivery',
    'biochar-split-percentage',
    'biochar-split-purchase',
    'dac-consumer-delivery',
    'dac-consumer-percentage',
    'dac-consumer-purchase',
    'dac-consumer-roundup',
    'dac-merchant-delivery',
    'dac-merchant-percentage',
    'dac-merchant-purchase',
    'dac-split-delivery',
    'dac-split-purchase',
    'dac-split-percentage',
    'reforestinguk-consumer-delivery',
    'reforestinguk-consumer-percentage',
    'reforestinguk-consumer-purchase',
    'reforestinguk-consumer-roundup',
    'reforestinguk-merchant-delivery',
    'reforestinguk-merchant-percentage',
    'reforestinguk-merchant-purchase',
    'reforestinguk-split-delivery',
    'reforestinguk-split-percentage',
    'reforestinguk-split-purchase',
]

const CheckoutImagesDesktop: FC<{
    chipSelection: (WhoPays | ContributionSize | Project)[]
}> = ({ chipSelection }) => (
    <>
        {desktopImageSlugs.map((slug, index) => {
            const imagePath = `/images/interactive-checkout/interactive-checkout-desktop-${slug}.png`

            const isActive = chipSelection.every((chip) => slug.includes(chip))

            return (
                <InteractiveGameDisplay
                    key={`interactive-map-bg-${index}`}
                    backgroundImageProperty={imagePath}
                    isActive={isActive}
                />
            )
        })}
    </>
)

export default CheckoutImagesDesktop
